import {
    Flex,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue,
    Tooltip,
    Link,
    Button
} from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
} from "react-table";
import { SearchBar } from 'components/navbar/searchBar/SearchBar';

// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
export default function ColumnsTable(props) {
    const { columnsData, tableData } = props;

    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);

    //   const tableInstance = useTable(
    //     {
    //       columns,
    //       data,
    //     },
    //     useGlobalFilter,
    //     useSortBy,
    //     usePagination
    //   );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        state,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
        setPageSize,
        setGlobalFilter  // <- add this back in
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 10 } // Set initial state here
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );


    //   const {
    //     getTableProps,
    //     getTableBodyProps,
    //     headerGroups,
    //     page,
    //     prepareRow,
    //     initialState,
    //   } = tableInstance;
    //   initialState.pageSize = 20;

    const textColor = useColorModeValue("secondaryGray.900", "white");
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");


    const [searchValue, setSearchValue] = useState("");

    const handleSearch = (e) => {
        const value = e.target.value || undefined;
        setGlobalFilter(value);
        setSearchValue(value);
    };

    return (
        <Card
            direction='column'
            w='100%'
            px='0px'
            overflowX={{ sm: "scroll", lg: "hidden" }}>
            <Flex px='25px' justify='space-between' mb='20px' align='center'>
                <Text
                    color={textColor}
                    fontSize='22px'
                    fontWeight='700'
                    lineHeight='100%'
                >
                    {/* Some text or leave it empty */}
                </Text>
                <SearchBar onChange={handleSearch} value={searchValue} />
            </Flex>
            <Flex px='25px' justify='space-between' mb='20px' align='center'>
                <Text
                    color={textColor}
                    fontSize='22px'
                    fontWeight='700'
                    lineHeight='100%'>

                </Text>
                <Menu />
            </Flex>
            <Table {...getTableProps()} variant='simple' color='gray.500' mb='24px'>
                <Thead>
                    {headerGroups.map((headerGroup, index) => (
                        <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                            {headerGroup.headers.map((column, index) => (
                                <Th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    pe='10px'
                                    key={index}
                                    borderColor={borderColor}>
                                    <Flex
                                        justify='space-between'
                                        align='center'
                                        fontSize={{ sm: "10px", lg: "12px" }}
                                        color='gray.400'>
                                        {column.render("Header")}
                                    </Flex>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()}>
                    {page.map((row, index) => {
                        prepareRow(row);
                        return (
                            <Tr {...row.getRowProps()} key={index}>
                                {row.cells.map((cell, index) => {
                                    let data = "";
                                    if (cell.column.Header === "PROTEIN") {
                                        // data = (
                                        //   <Flex align='center'>
                                        //     <Text color={textColor} fontSize='sm' fontWeight='700'>
                                        //       {cell.value}
                                        //     </Text>
                                        //   </Flex>
                                        // );
                                        data = (
                                            <Tooltip label="Click for details" aria-label="A tooltip">
                                                <Link href={`/#/admin/detail/${cell.value}`} isExternal>
                                                    <Text color={textColor} fontSize='sm' fontWeight='700'>
                                                        {cell.value}
                                                    </Text>
                                                </Link>
                                            </Tooltip>
                                        );
                                    } else if (cell.column.Header === "GENE") {
                                        data = (
                                            <Flex align='center'>
                                                <Text
                                                    me='10px'
                                                    color={textColor}
                                                    fontSize='sm'
                                                    fontWeight='700'>
                                                    {cell.value}
                                                </Text>
                                            </Flex>
                                        );
                                    } else if (cell.column.Header === "NAME") {
                                        data = (
                                            <Text color={textColor} fontSize='sm' fontWeight='700'>
                                                {cell.value}
                                            </Text>
                                        );
                                    } else if (cell.column.Header === "DATE") {
                                        data = (
                                            <Text color={textColor} fontSize='sm' fontWeight='700'>
                                                {cell.value}
                                            </Text>
                                        );
                                    }
                                    return (
                                        <Td
                                            {...cell.getCellProps()}
                                            key={index}
                                            fontSize={{ sm: "14px" }}
                                            minW={{ sm: "150px", md: "200px", lg: "auto" }}
                                            borderColor='transparent'>
                                            {data}
                                        </Td>
                                    );
                                })}
                            </Tr>
                        );
                    })}
                </Tbody>
            </Table>
            <Flex mt="4" justifyContent="space-between" alignItems="center">
                <Button
                    onClick={() => previousPage()}
                    isDisabled={!canPreviousPage}
                    colorScheme="teal"
                >
                    Previous
                </Button>
                <Text fontSize="lg">
                    Page <strong>{state.pageIndex + 1}</strong> of {pageCount}
                </Text>
                <Button
                    onClick={() => nextPage()}
                    isDisabled={!canNextPage}
                    colorScheme="teal"
                >
                    Next
                </Button>
            </Flex>

        </Card>
    );
}
